import { createRouter, createWebHistory } from 'vue-router'
import { TokenService } from '@/services/token.service'
import GoogleRedirectLayout from '@/views/layout/GoogleRedirectLayout.vue'
import PagesView from '@/views/page/PagesView.vue'
import { stockRoutes } from '@/router/stock.router.ts'
import { saleRoutes } from '@/router/sale.router.ts'
import { partRoutes } from '@/router/part.router.ts'
import { accountItemRoutes } from '@/router/account.item.router.ts'
import { explodedRoutes } from './exploded.router.ts'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      redirect: '/p/home',
    },
    {
      path: '/p/',
      component: PagesView,
      children: [
        {
          path: '',
          redirect: '/p/home',
        },
        {
          path: 'home',
          name: 'home',
          component: () => import('@/views/page/home/HomeData.vue'),
          meta: {
            title: 'Home',
          },
        },
        ...stockRoutes,
        ...saleRoutes,
        ...partRoutes,
        ...accountItemRoutes,
        ...explodedRoutes,
      ],
    },
    {
      path: '/welcome',
      name: 'welcome',
      component: () => import('../views/layout/WelcomeLayout.vue'),
      meta: {
        title: 'Welcome to Panatech',
        public: true,
        onlyWhenLoggedOut: true,
      },
    },
    {
      path: '/google/callback',
      name: 'google-callback',
      component: GoogleRedirectLayout,
      meta: {
        title: '⌛ logging in with Google...',
        public: true,
        onlyWhenLoggedOut: true,
      },
    },
    {
      path: '/stock/unpaid',
      name: 'stock-unpaid',
      component: () => import('../views/layout/stock/StockBillReceipt.vue'),
      meta: {
        title: 'Bill | Unpaid Stock',
      },
    },
    {
      path: '/sale/:id/barcode',
      name: 'sale-barcode',
      component: () => import('../views/layout/sale/SaleBarcode.vue'),
      meta: {
        title: 'Barcode Sale',
      },
    },
  ],
})

router.beforeEach((to, _, next) => {
  const isPublic = to.matched.some((record) => record.meta.public)
  const onlyWhenLoggedOut = to.matched.some((record) => record.meta.onlyWhenLoggedOut)
  const loggedIn = !!TokenService.getToken()

  if (!isPublic && !loggedIn) {
    return next({
      path: '/welcome',
      query: { redirect: to.fullPath },
    })
  }

  if (loggedIn && onlyWhenLoggedOut) {
    return next('/p/home')
  }

  // title document
  document.title = to.meta.title || import.meta.env.VITE_APP_NAME

  next()
})

export default router
